<template>
  <div>Signing in...</div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import userManager from "@/plumbing/auth";
import userStore from "@/store/userStore";

@Component
export default class SignInCallback extends Vue {
  userStore = userStore;

  async mounted() {
    try {
      //Handle back button takes to sign in redirect issue, when just after landing on home page.
      //After sign in the first time, state info will lost in cache
      //Calling userManager.signinCallback() again will throw exception
      let user = await userManager.getUser();
      if (user == null) {
        user = await userManager.signinCallback();
        userStore.setUser(user);
      }

      if (this.$router.currentRoute.name !== "SignInCallbackSilent") this.$router.push("/");
    } catch (err) {
      console.error(err);
      this.$router.push("/error");
    }
  }
}
</script>
